// action - state management
import { REGISTER, LOGIN, LOGOUT } from './actions';

// initial state
export const initialState = {
  isAdmin: false,
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        // ...state,
        user
      };
    }
    case LOGIN: {
      return {
        // ...state,
        isInitialized: true,
        ...action.payload
      };
    }
    case LOGOUT: {
      return {
        // ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null
      };
    }
    default: {
      return state;
    }
  }
};

export default auth;
